import React from 'react';
import {Store} from './Store';

export const wrapRootElement = ({element}) => (
        <Store>{element}</Store>
);
